// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__N2_iq","inputDescription":"styles_inputDescription__1xQUO"};